import React, { useEffect } from "react";

import TrainingDatesImage from "../../assets/TrainingDates.png";
import ChromeWebStoreImage from "../../assets/chromeWebStore.png";
import { PopupWidget } from "react-calendly";

const TrainingDates = (props) => {
  // const url = "https://calendly.com/johns-hopkins";
  // useEffect(() => {
  //   const head = document.querySelector("head");
  //   const script = document.createElement("script");
  //   script.setAttribute(
  //     "src",
  //     "https://assets.calendly.com/assets/external/widget.js"
  //   );
  //   head.appendChild(script);
  //   let link = document.createElement("link");
  //   link.rel = "stylesheet";
  //   link.href = "https://assets.calendly.com/assets/external/widget.css";
  //   document.head.appendChild(link);
  // }, []);
  return (
    <div id="TrainingDates">
      <div className="TrainingDates__wrap">
        <div className="TrainingDates__title">Upcoming Training Dates</div>
 
        {/* <InlineWidget url={url} /> */}
        <img
          className="TrainingDates__chromeWebStore"
          src={ChromeWebStoreImage}
          alt=""
        />
        <button
          onClick={() =>
            window.open(
              "https://chrome.google.com/webstore/detail/ziplyne-jh-production-hyb/iolklpfjcbghlmaojgdcdjagkebcmkag?hl=en&authuser=0"
            )
          }
          className="TrainingDates__downloadButton"
        >
          Click to Download JH-Production Creator
        </button>
        <button
          onClick={() =>
            window.open(
              "https://chrome.google.com/webstore/detail/ziplyne-jh-production-pla/phaofcagillefigmcbocnnllnflhkjce?hl=en&authuser=0"
            )
          }
          className="TrainingDates__downloadButton"
        >
          Click to Download JH-Production Player
        </button>
        <button
          onClick={() =>
            window.open(
              "https://chrome.google.com/webstore/detail/ziplyne-jh-staging-hybrid/dpcjihdeiilacnagdoplphghajdhegjc?hl=en&authuser=0"
            )
          }
          className="TrainingDates__downloadButton"
        >
          Click to Download JH-Staging Creator
        </button>
        <button
          onClick={() =>
            window.open(
              "https://chrome.google.com/webstore/detail/ziplyne-jh-staging-player/khhpjplbjeafbecbbahhkkgkepjckkgi?hl=en&authuser=0"
            )
          }
          className="TrainingDates__downloadButton"
        >
          Click to Download JH-Staging Player
        </button>
        <button
          onClick={() => window.open("https://calendly.com/johns-hopkins")}
          className="TrainingDates__CalendlyBtn"
        >
          Sign Up For Ziplyne Training
        </button>
        <button
          onClick={() =>
            window.open(
              "http://help.ziplyne.com/en/articles/4872835-installation-of-creator-player-extensions-from-chrome-store"
            )
          }
          className="TrainingDates__instructButton"
        >
          How to Install Ziplyne Extension
        </button>
        <button
          onClick={() => window.open("http://help.ziplyne.com/en")}
          className="TrainingDates__instructButton"
        >
          Ziplyne Help Center
        </button>
      </div>
      <img
        className="TrainingDates--background"
        src={TrainingDatesImage}
        alt=""
      />
    </div>
  );
};

export default TrainingDates;
